import { type ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useCiAuthStore } from '../auth/ciAuthStore';
import { useCiPoolStore } from '../authorization/ciPoolStore';
import { CiPoolSelector } from './CiPoolSelector';
import type { AuthorizedPool } from '../data/types';

interface Props {
  pools: AuthorizedPool[];
  children: ReactNode;
}

export function CiLayout({ pools, children }: Props) {
  const navigate = useNavigate();
  const username = useCiAuthStore((s) => s.username);
  const logout = useCiAuthStore((s) => s.logout);
  const selectedLeagueId = useCiPoolStore((s) => s.selectedLeagueId);
  const setSelectedLeagueId = useCiPoolStore((s) => s.setSelectedLeagueId);
  const clearPool = () => setSelectedLeagueId(null);

  const onLogout = () => {
    logout();
    clearPool();
    navigate('/ci-dashboard/auth', { replace: true });
  };

  return (
    <div className="ci-dashboard">
      <div className="ci-shell">
        <header className="ci-header">
          <div className="ci-header__brand">
            Community Intelligence Dashboard
            <small>Analyse d’activité pour opérateurs de pool</small>
          </div>
          <div className="ci-header__user">
            <CiPoolSelector
              pools={pools}
              selectedLeagueId={selectedLeagueId}
              onChange={setSelectedLeagueId}
            />
            {username && <span>Connecté : {username}</span>}
            <button type="button" className="ci-header__logout" onClick={onLogout}>
              Se déconnecter
            </button>
          </div>
        </header>
        <nav className="ci-nav" aria-label="Navigation">
          <NavLink
            to="/ci-dashboard"
            end
            className={({ isActive }) => `ci-nav__link${isActive ? ' is-active' : ''}`}
          >
            Vue d’ensemble
          </NavLink>
          <NavLink
            to="/ci-dashboard/players"
            className={({ isActive }) => `ci-nav__link${isActive ? ' is-active' : ''}`}
          >
            Joueurs
          </NavLink>
          <NavLink
            to="/ci-dashboard/activity"
            className={({ isActive }) => `ci-nav__link${isActive ? ' is-active' : ''}`}
          >
            Activité
          </NavLink>
          <NavLink
            to="/ci-dashboard/pages"
            className={({ isActive }) => `ci-nav__link${isActive ? ' is-active' : ''}`}
          >
            Pages consultées
          </NavLink>
          <NavLink
            to="/ci-dashboard/opportunities"
            className={({ isActive }) => `ci-nav__link${isActive ? ' is-active' : ''}`}
          >
            Opportunités
          </NavLink>
        </nav>
        <main className="ci-main">{children}</main>
      </div>
    </div>
  );
}
